import { render } from "./ShopTemp.vue?vue&type=template&id=c4e2112c&scoped=true"
import script from "./ShopTemp.vue?vue&type=script&lang=js"
export * from "./ShopTemp.vue?vue&type=script&lang=js"

import "./ShopTemp.vue?vue&type=style&index=0&id=c4e2112c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4e2112c"]])

export default __exports__